import React from 'react';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const openGetStarted = () => {
    window.open('https://forms.gle/rU28UfypBujmWmQK9', '_blank');
  };

  const scrollToHowItWorks = () => {
    document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      data-testid="hero-section"
      className="pt-36 pb-24 md:pt-44 md:pb-36 hero-gradient"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block bg-[#EFF6FF] text-[#2563EB] text-sm font-semibold px-4 py-1.5 rounded-full mb-6 tracking-wide">
            AI voice agents for Indian D2C brands
          </span>

          <h1
            data-testid="hero-headline"
            className="font-['DM_Sans'] text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1C1917] tracking-tight leading-tight"
          >
            They left your cart.{' '}
            <span className="text-[#2563EB]">We call them back.</span>
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            data-testid="hero-subheadline"
            className="mt-6 text-base md:text-lg text-[#57534E] leading-relaxed max-w-2xl mx-auto"
          >
            AI-powered voice agents that recover abandoned carts — calling your customers in
            their own language, at the right moment, and converting.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <Button
              data-testid="hero-cta"
              onClick={openGetStarted}
              className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-full px-8 py-6 text-lg font-semibold btn-shine group"
            >
              Get 100 free calls
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
            <button
              onClick={scrollToHowItWorks}
              className="text-[#57534E] hover:text-[#1C1917] font-medium transition-colors underline underline-offset-4"
            >
              See how it works
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10"
          >
            {[
              { value: '10+', label: 'Indian languages supported' },
              { value: '₹6', label: 'per minute, no lock-in' },
              { value: '100', label: 'calls free to start' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl font-bold text-[#1C1917] font-['DM_Sans']">{stat.value}</div>
                <div className="text-sm text-[#78716C] mt-0.5">{stat.label}</div>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
